import './ErrorBoundary.less';
import React, {useEffect, useContext, useRef} from 'react';
import {useHistory} from 'react-router-dom';
import NotFoundError from "../../../errors/not-found/NotFoundError";
import ForbiddenError from "../../../errors/forbidden/ForbiddenError";
import UnexpectedError from "../../../errors/unexpected/UnexpectedError";
import ErrorContext from "../../../contexts/error/ErrorContext";


export default function ErrorBoundary({}) {

    const {error, setError} = useContext(ErrorContext);

    const history = useHistory();

    const locRef = useRef(history.location.pathname);

    useEffect(() => {
        if (locRef.current !== history.location.pathname) {
            setError(null);
        }
    }, [history.location.pathname]);

    return <div className="error-boundary">
        {
            error === 'NotFound' &&
            <NotFoundError/>
        }
        {
            error === 'Forbidden' &&
            <ForbiddenError/>
        }
        {
            error === 'Unexpected' &&
            <UnexpectedError/>
        }
    </div>;
}
